import { post, fetchSignedUrl } from "../fetch.v2"
import { IUploadCreate } from "../../interfaces/upload"
import { getDomainId, getEventId } from "../../utils/store"

class UploadApi {
  url: string

  constructor() {
    const domainId = getDomainId()
    const eventId = getEventId()
    this.url = eventId
      ? `/domains/${domainId}/events/${eventId}/upload`
      : `/domains/${domainId}/upload`
  }

  async createUrlToUpdate(upload: IUploadCreate, file: File | Blob) {
    return post(`${this.url}/update`, upload).then(url =>
      fetchSignedUrl("PUT", url, file)
    )
  }

  async createUrlToGet(upload: IUploadCreate) {
    return post(`${this.url}/get`, upload).then(url => {
      return fetch(url).then(response =>
        response.ok ? response.arrayBuffer() : null
      )
    })
  }
}

export default UploadApi
